export default __webpack_public_path__ + "static/SmartMarkScheme-71a8659e25d3f93efa1d47ff4b17fb59.png";